import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'

const Icon = ({ icon, className, visible = true, ...props }) => {
  if (!icon) {
    return null
  }

  let iconName = icon
  let collection = 'far'

  if (Array.isArray(icon)) {
    collection = icon[0]
    iconName = icon[1]
  }

  collection = {
    fas: 'solid',
    far: 'regular',
    fab: 'brands',
    fal: 'solid', // Light icons not available, fallback to solid
  }[collection] || 'solid'

  if (!iconName.length) {
    return null
  }

  return (
    <FontAwesomeIcon
      icon={`fa-${collection} fa-${iconName}`}
      className={classNames({
        'hidden': !visible,
      }, className)}
      {...props}
    />
  )
}

export default Icon
